// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3NGvB","inputWrap":"Table_inputWrap__1dacj","col":"Table_col__3766C","bmiTooltip":"Table_bmiTooltip__5njBf"};